export const linkBroken = "link-broken";
export const pageNotFound404 = "404-not-found";
export const noContent = "no-content";
